import Accordian from "@components/Accordian/Accordian";
import { Grid } from "@mui/material";
import Checkbox from "@mv-components/Checkbox/Checkbox";
import styles from "./styles";
import { AccordionCheckboxGroupPropsInterface } from "@mv-components/types";
import useStyles from "@hooks/useStyle";

const AccordionCheckboxGroup = (props: AccordionCheckboxGroupPropsInterface) => {
	const { children, trigger, direction, onChange, iconProps } = props;
	const { classes } = useStyles(styles) as any;
	return (
		<Accordian iconProps={iconProps} trigger={trigger} defaultExpanded={props.defaultExpanded}>
			<Grid
				container
				direction={direction === "vertical" ? "column" : "row"}
				className={classes.checkboxContainer}
			>
				{children?.map((child, index: any) => (
					<Checkbox
						labelClassName="t14"
						{...child}
						key={index}
						label={child.label}
						onChange={({ event, itemKey, parentKey }: any) => onChange({ event, itemKey, parentKey })}
					/>
				))}
			</Grid>
		</Accordian>
	);
};

export default AccordionCheckboxGroup;
